import React from 'react';
import { Save } from 'lucide-react';

interface NotificationSettings {
  emailAlerts: boolean;
  pushNotifications: boolean;
  maintenanceUpdates: boolean;
  securityAlerts: boolean;
}

interface NotificationsTabProps {
  notifications: NotificationSettings;
  setNotifications: (data: NotificationSettings) => void;
  onSave: () => Promise<void>;
  saving?: boolean;
}

const NotificationsTab: React.FC<NotificationsTabProps> = ({
  notifications,
  setNotifications,
  onSave,
  saving = false,
}) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-slate-900 dark:text-slate-100 mb-4">
          Notification Preferences
        </h3>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-sm font-medium text-slate-900 dark:text-slate-100">
                Email Alerts
              </h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Receive alerts via email when issues occur
              </p>
            </div>
            <input
              type="checkbox"
              checked={notifications.emailAlerts}
              onChange={(e) =>
                setNotifications({ ...notifications, emailAlerts: e.target.checked })
              }
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-slate-300 dark:border-slate-600 rounded"
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-sm font-medium text-slate-900 dark:text-slate-100">
                Push Notifications
              </h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Receive browser push notifications
              </p>
            </div>
            <input
              type="checkbox"
              checked={notifications.pushNotifications}
              onChange={(e) =>
                setNotifications({ ...notifications, pushNotifications: e.target.checked })
              }
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-slate-300 dark:border-slate-600 rounded"
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-sm font-medium text-slate-900 dark:text-slate-100">
                Maintenance Updates
              </h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Get notified about scheduled maintenance
              </p>
            </div>
            <input
              type="checkbox"
              checked={notifications.maintenanceUpdates}
              onChange={(e) =>
                setNotifications({ ...notifications, maintenanceUpdates: e.target.checked })
              }
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-slate-300 dark:border-slate-600 rounded"
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-sm font-medium text-slate-900 dark:text-slate-100">
                Security Alerts
              </h4>
              <p className="text-sm text-slate-500 dark:text-slate-400">
                Critical security notifications
              </p>
            </div>
            <input
              type="checkbox"
              checked={notifications.securityAlerts}
              onChange={(e) =>
                setNotifications({ ...notifications, securityAlerts: e.target.checked })
              }
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-slate-300 dark:border-slate-600 rounded"
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end">
        <button
          onClick={onSave}
          disabled={saving}
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
        >
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Saving...' : 'Save Preferences'}
        </button>
      </div>
    </div>
  );
};

export default NotificationsTab;